//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-cigent-header',
    templateUrl: './cigent-header.component.html',
    styleUrls: ['./cigent-header.component.scss'],
    standalone: false
})
export class CigentHeaderComponent {
  @Input() smallTitle: string;
  @Input() largeTitle: string;
  @Input() description: string;
  @Input() descriptionMarginRight: string;

  constructor() {
    this.smallTitle = "CIGENT | SELECT";
    this.largeTitle = "FILE SECURITY ON YOUR PC AND WHEREVER FILES GO";
    this.description = "Protect any file on your PC, clouds, and wherever files go with " +
        "file encryption, zero trust file access, and secure file sharing. Optionally, " +
        "use an Opal SED to make files invisible protected by tamper-proof credentials."
    this.descriptionMarginRight = '100px';
  }

}
